import PropTypes from 'prop-types';
import React from 'react';
import SessionStore from 'stores/shared/session';
import { t, loadLocales } from 'services/translation';
import _ from 'underscore';

import './index.scss';

class GlobalError extends React.PureComponent {
  static displayName = 'GlobalError-Plugins';

  static propTypes = {
    statusCode: PropTypes.number,
    statusMessages: PropTypes.object,
    defaultErrorMessage: PropTypes.string,
    showButton: PropTypes.bool,
  };

  static defaultProps = (function () {
    return {
      statusCode: null,
      showButton: true,
    };
  })();

  UNSAFE_componentWillMount() {
    const languageParam = new URL(window.location.href).searchParams.get(
      'lang'
    );
    loadLocales(languageParam || SessionStore.state.get('i18n'));
  }

  messageForStatus = () => {
    const errorMessage = `${t(
      'SOMETHING_WENT_WRONG_WHEN_TRYING_TO_PROCESS_YOUR_REQUEST'
    )}.`;

    return _.extend(
      {
        404: errorMessage,
        410: errorMessage,
      },
      this.props.statusMessages
    );
  };

  _errorMessage = () => {
    const defaultErrorMessage = `${t(
      'SOMETHING_WENT_WRONG_WHEN_TRYING_TO_PROCESS_YOUR_REQUEST'
    )}.`;
    return (
      this.messageForStatus()[this.props.statusCode] || defaultErrorMessage
    );
  };

  _handleClick = (e) => {
    e.preventDefault();
    location.reload();
  };

  _renderButton = () => {
    return (
      <div className="GlobalError-ButtonContainer">
        <a href="#" onClick={this._handleClick} className="ui button brand-bg">
          {t('REFRESH')}
        </a>
      </div>
    );
  };

  render() {
    return (
      <div className="GlobalError-Container">
        <div className="GlobalError-Message">
          <h1>
            <span className="text">{t('OOPS')}!</span>
            <span className="icon af-globalerror brand-color" />
          </h1>
          <p>{this._errorMessage()}</p>
          <p>{t('PLEASE_REFRESH_YOUR_PAGE_AND_TRY_AGAIN')}.</p>
        </div>
        {this.props.showButton && this._renderButton()}
      </div>
    );
  }
}

export default GlobalError;
